import Vue from 'vue'

export const vp = Vue.prototype
